import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ProductsService } from '../../service/main/products.service';
import { ParkingsService } from '../../service/main/parkings.service';
import { ToastrService } from '../../service/common/toastr.service';
import { Router } from '@angular/router';
import { Product } from '../../entity';
import { isNullOrUndefined } from 'util';
import { IDropdown } from '../../interfaces';

@Component({
    selector: 'app-product-add',
    templateUrl: './product-add.component.html',
    styleUrls: ['./product-add.component.css']
})
export class ProductAddComponent implements OnInit {
    product: Product = new Product();
    parkings: IDropdown[] = [];
    tariffs: IDropdown[] = [];

    constructor(
        private productsService: ProductsService,
        private parkingsService: ParkingsService,
        private toastrService: ToastrService,
        private router: Router
    ) { }

    ngOnInit() {
        this.refresh();
    }

    registerProduct(form: NgForm) {
        if (form.valid && !isNullOrUndefined(this.product.TariffID) && !isNullOrUndefined(this.product.ParkingID)) {
            this.productsService.createProduct(this.product).subscribe(data => {
                this.toastrService.success('Product successfully added.');
                form.reset();
                this.router.navigate(['products']);
            }, err => {
                this.toastrService.error('A error has occurred while adding the product.');
            });
        } else {
            this.toastrService.error('All fields are required.');
        }
    }

    refresh() {
        this.parkingsService.getParkingLots().subscribe(data => {
            const parkings: IDropdown[] = [];
            data.forEach((item) => {
                const parking: IDropdown = {
                    text: item.title,
                    id: item.parkingID
                };
                parkings.push(parking);
            });
            this.parkings = parkings;
        });
    }

    selectParking(parking: IDropdown) {
        this.product.ParkingID = Number(parking.id);
        this.parkingsService.getParkingTariffs(parking.id).subscribe(data => {
            const tariffs: IDropdown[] = [];
            data.forEach(item => {
                const tariff: IDropdown = {
                    text: `${item.price} ${item.tariffType}`,
                    id: item.tariffID
                };

                tariffs.push(tariff);
            });
            this.tariffs = tariffs;
        });
    }

    removeSelectedParking() {
        this.product.ParkingID = null;
        this.product.TariffID = null;
        this.tariffs = [];
    }

    selectTariff(tariff: IDropdown) {
        this.product.TariffID = Number(tariff.id);
    }

    removeSelectedTariff() {
        this.product.TariffID = null;
    }

    cancel() {
        this.router.navigate(['products']);
    }

}
